import React from 'react';
import Icon from '@material-ui/core/Icon';
import cross from '@assets/cross.svg';

function CrossIcon() {
  return (
    <Icon>
      <img alt="arrow" src={cross} style={{ display: 'block' }} />
    </Icon>
  );
}

export default CrossIcon;
